import Intercom from '@intercom/messenger-js-sdk'

const ChatWidget = () => (
  <Intercom app_id="gaxgtx5z" />
)

export default ChatWidget
